import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doGet, doPost, doPut } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";

export const ESGChatAction = createAsyncThunk("esgChat",
    async (arg, { rejectWithValue }) => {
        try {
            const response = await doPost(urls?.esgChat, arg);
            return response;
        } catch (error) {
            return rejectWithValue(error)
        }
    })

export const ESGChatControversyAction = createAsyncThunk("esgChatControversy",
    async (arg, { rejectWithValue }) => {
        try {
            const response = await doPost(urls?.esgChatControversy, arg);
            return response;
        } catch (error) {
            return rejectWithValue(error)
        }
    })

export const ESGChatFeedbackAction = createAsyncThunk("chatFeedback",
    async (arg, { rejectWithValue }) => {
        try {
            const response = await doPut(`${urls.esgChatFeedBack}/${arg.id}`, arg.payload);
            return response;
        } catch (error) {
            return rejectWithValue(error)
        }
    })

export const ESGChatFoldersAction = createAsyncThunk("chatFolders",
    async (_, { rejectWithValue }) => {
        try {
            const response = await doGet(urls?.esgChatFolders);
            return response;
        } catch (error) {
            return rejectWithValue(error)
        }
    })

export const ESGChatSignedUrlAction = createAsyncThunk("chatSignedUrl",
    async (arg, { rejectWithValue }) => {
        try {
            const response = await doPost(urls?.esgChatSignedUrl, arg);
            return response;
        } catch (error) {
            return rejectWithValue(error)
        }
    })

export const ESGChatSlice = createSlice({
    name: "esgChat",
    initialState: {
        isLoading: false,
        data: false,
        error: null,
        success: false,
    },
    reducers: {
        ESGChatReset: () => {
            return {
                isLoading: false,
                data: false,
                error: null,
                success: false
            };
        },
    },
    extraReducers: {
        [ESGChatAction.pending]: (state) => {
            state.isLoading = true;
            state.error = null;
            state.success = false;
        },
        [ESGChatAction.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.data = payload;
            state.error = null;
            state.success = true;
        },
        [ESGChatAction.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
            state.success = false;
        },
    }
})

export const ESGChatControversySlice = createSlice({
    name: "esgChatControversy",
    initialState: {
        isLoading: false,
        data: false,
        error: null,
        success: false,
    },
    reducers: {
        ESGChatControversyReset: () => {
            return {
                isLoading: false,
                data: false,
                error: null,
                success: false
            };
        },
    },
    extraReducers: {
        [ESGChatControversyAction.pending]: (state) => {
            state.isLoading = true;
            state.error = null;
            state.success = false;
        },
        [ESGChatControversyAction.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.data = payload;
            state.error = null;
            state.success = true;
        },
        [ESGChatControversyAction.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
            state.success = false;
        },
    }
})

export const ESGChatFeedbackSlice = createSlice({
    name: "chatFeedback",
    initialState: {
        isLoading: false,
        data: false,
        error: null,
        success: false,
    },
    reducers: {
        ESGChatFeedbackReset: () => {
            return {
                isLoading: false,
                data: false,
                error: null,
                success: false,
            };
        },
    },
    extraReducers: {
        [ESGChatFeedbackAction.pending]: (state) => {
            state.isLoading = true;
            state.error = null;
            state.success = false;
        },
        [ESGChatFeedbackAction.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.data = payload;
            state.error = null;
            state.success = true;
        },
        [ESGChatFeedbackAction.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
            state.success = false;
        },
    }
})

export const ESGChatFoldersSlice = createSlice({
    name: "chatFolders",
    initialState: {
        isLoading: false,
        data: false,
        error: null,
        success: false,
    },
    reducers: {
        ESGChatFoldersReset: () => {
            return {
                isLoading: false,
                data: false,
                error: null,
                success: false,
            };
        },
    },
    extraReducers: {
        [ESGChatFoldersAction.pending]: (state) => {
            state.isLoading = true;
            state.error = null;
            state.success = false;
        },
        [ESGChatFoldersAction.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.data = payload;
            state.error = null;
            state.success = true;
        },
        [ESGChatFoldersAction.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
            state.success = false;
        },
    }
})

export const ESGChatSignedUrlSlice = createSlice({
    name: "chatSignedUrl",
    initialState: {
        isLoading: false,
        data: false,
        error: null,
        success: false,
    },
    reducers: {
        ESGChatSignedUrlReset: () => {
            return {
                isLoading: false,
                data: false,
                error: null,
                success: false,
            };
        },
    },
    extraReducers: {
        [ESGChatSignedUrlAction.pending]: (state) => {
            state.isLoading = true;
            state.error = null;
            state.success = false;
        },
        [ESGChatSignedUrlAction.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.data = payload;
            state.error = null;
            state.success = true;
        },
        [ESGChatSignedUrlAction.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
            state.success = false;
        },
    }
})


export const { ESGChatReset } = ESGChatSlice.actions
export const { ESGChatFeedbackReset } = ESGChatFeedbackSlice.actions
export const { ESGChatFoldersReset } = ESGChatFoldersSlice.actions
export const { ESGChatSignedUrlReset } = ESGChatSignedUrlSlice.actions
export const { ESGChatControversyReset } = ESGChatControversySlice.actions